"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoComplete = void 0;
var util_1 = require("./util");
var videoComplete = function (event) {
    return (0, util_1.videoEvent)(event, "video-complete");
};
exports.videoComplete = videoComplete;
